// @flow
import { goBack } from "../_router/RouterActions";
import { updateForm } from "../_modularui/ModularUIActions";
import { logoutSuccess } from "./SignOut";
import { reloadApplication } from "./Application";
import { startProgress, finishProgress } from "./ProgressIndicator";

import Authenticate from "../../modularui/Authenticate";

import type { Dispatch, GetState, ThunkAction } from "../types";
import type FormModel from "../../models/form/FormModel";
import type { UpdateFormAction } from "../_modularui/types";

/**
 * Go back to previous object (back button on form)
 */
export const previousObject = (form: FormModel): UpdateFormAction => {
  const newForm = form.clone();

  newForm.setPreviousObject();

  return updateForm(newForm);
};

/**
 */
export const cancelForm =
  (form: FormModel): ThunkAction<> =>
  (dispatch: Dispatch, getState: GetState) => {
    if (form.key === "ChangePassword" && getState().auth.mustChangePassword) {
      dispatch(startProgress());
      return new Authenticate().logout().then(() => {
        dispatch(logoutSuccess());
        dispatch(reloadApplication());
        dispatch(finishProgress());

        return dispatch(goBack());
      });
    }

    return dispatch(goBack());
  };
